import type { ReactNode } from 'react';

/** Big screen title + supporting line. */
export function AuthTitle({ title, subtitle }: { title: string; subtitle?: ReactNode }) {
  return (
    <div>
      <h1 className="title text-[30px]">{title}</h1>
      {subtitle && (
        <p className="mt-2 text-[14px] font-medium leading-[1.45] text-ink2">{subtitle}</p>
      )}
    </div>
  );
}
